import React from 'react'
import PropTypes from 'prop-types'
import { LazyLoadImage } from 'react-lazy-load-image-component'

import { CancelIcon } from 'images'

// Bare interstitial card: same bare image + white content panel as
// BareStackedCard, but with a "Close" button in the top-right corner and
// BOTH a text "Close" action and a "Learn more" button in the panel footer —
// distinguishes this skin from the single-button stacked card (Figma nodes
// 31513:16272/16306 — see googleDisplayVariations.js).
const InterstitialCard = ({ ad }) => {
  const { headline, description, media, logo, businessName, callToAction } = ad

  return (
    <div className="google-display-card google-display-card--interstitial">
      <button type="button" className="google-display-card__close" aria-label="Close">
        <CancelIcon />
      </button>
      {/* visibleByDefault: see BareGradientCard.jsx — avoids the lazy-load
          placeholder's raw-pixel inline height inflating a horizontally-
          scrolling row for any card not yet scrolled into view. */}
      <LazyLoadImage
        className="google-display-card__media"
        src={media?.url}
        alt={media?.filename}
        width={media?.width}
        height={media?.height}
        visibleByDefault
      />
      <div className="google-display-card__panel">
        {logo?.url && (
          <img className="google-display-card__logo google-display-card__logo--centered" src={logo.url} alt={businessName} />
        )}
        <div className="google-display-card__headline google-display-card__headline--centered">{headline}</div>
        <div className="google-display-card__description">{description}</div>
        <div className="google-display-card__dual-actions">
          <span className="google-display-card__cta-text">Close</span>
          <button type="button" className="google-display-card__cta-pill">
            {callToAction}
          </button>
        </div>
      </div>
    </div>
  )
}

InterstitialCard.propTypes = {
  ad: PropTypes.shape({
    headline: PropTypes.string,
    description: PropTypes.string,
    callToAction: PropTypes.string,
    media: PropTypes.object,
    logo: PropTypes.object,
    businessName: PropTypes.string,
  }).isRequired,
}

export default InterstitialCard
